module.exports = __webpack_public_path__ + "static/media/0208_Medium.dabdbe2f.jpg";